import { render, staticRenderFns } from "./checkoutRoom.vue?vue&type=template&id=f5c70012"
import script from "./checkoutRoom.vue?vue&type=script&lang=js"
export * from "./checkoutRoom.vue?vue&type=script&lang=js"
import style0 from "./checkoutRoom.vue?vue&type=style&index=0&id=f5c70012&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports